import PropTypes from 'prop-types';
import React from 'react';
import style from './TopRowInput.module.css';

export const TopRowInput = ({
  qty,
  setQty,
  backgroundColor,
  width,
  justifyContent,
}) => {
  return (
    <div
      style={{ backgroundColor, width, justifyContent }}
      className={style.box}
    >
      <input
        className={style.input}
        type="number"
        value={qty}
        onChange={({ target }) => setQty(target.value)}
      />
    </div>
  );
};

TopRowInput.propTypes = {
  backgroundColor: PropTypes.any,
  justifyContent: PropTypes.any,
  qty: PropTypes.any,
  setQty: PropTypes.func,
  width: PropTypes.any
};
